export default function renderCurrency(value: any) {
  return parseFloat(value).toLocaleString('en-GB', {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
}